import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AskValue from "../global/BidAsk/AskValue";
import BidValue from "../global/BidAsk/BidValue";

const defaultRender = (value) => (value ? value : "0.00");

const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const formattedDate = date.toISOString().slice(0, 19);
    const milliseconds = date.getMilliseconds();
    const formattedMilliseconds = (milliseconds / 1000).toFixed(2).slice(2);
    return `${formattedDate}.${formattedMilliseconds}`;
};
const formatPrice = (value, decimalPlaces) => {
    if (value === null || value === undefined) return "";
    return Number(value).toFixed(decimalPlaces);
};


const usePendingOrderCell = () => {
    const { t } = useTranslation();
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);


    return React.useMemo(() => ([
        { title: t("time"), dataIndex: 'dateTime', render: (value) => formatDateTime(value), },
        { title: t("id"), dataIndex: 'id', render: defaultRender, },
        { title: t('symbol'), dataIndex: 'symbolName', render: defaultRender, },
        { title: t('price'), dataIndex: 'price', render: (value) => formatPrice(value, decimalPlaces), },
        { title: t('currentPrice'), dataIndex: 'currentPrice', render: (value, row) => row?.side == -1 ? <AskValue symbolId={row.symbolId} digits={decimalPlaces} /> : <BidValue symbolId={row.symbolId} digits={decimalPlaces} />, },
        // {
        //       title: t("currentPrice"), dataIndex: "currentPrice", render: (value, row) => {
        //         return row?.side == -1 ? <AskValue symbolId={row.symbolId} digits={decimalPlaces} /> : <BidValue symbolId={row.symbolId} digits={decimalPlaces} />
        //       }
        //     },
        { title: t('amount'), dataIndex: 'amount', render: (value) => formatPrice(value, decimalPlaces), },
        { title: t('s/l'), dataIndex: 'stopLoss', render: (value) => formatPrice(value, decimalPlaces), },
        { title: t('t/p'), dataIndex: 'takeProfit', render: (value) => formatPrice(value, decimalPlaces), },
        { title: t("comment"), dataIndex: "comment", render: defaultRender },
    ]));
};

export default usePendingOrderCell;
